import React from 'react'
import {FaCheckCircle} from 'react-icons/fa'
import Notice from '@components/V3/Notice'
import Text from '@components/V3/Text'
import isDummyTransaction from '@page-components/TrackV2/helpers/isDummyTransaction'
import {useTranslation} from 'next-i18next'

import NoTransaction from './NoTransaction'
import useTransaction from './useTransaction.main'

export default function Transaction() {
  const transaction = useTransaction()
  const {t} = useTranslation('tracking', {keyPrefix: 'order.inner.transaction'})

  if (!transaction) {
    return <NoTransaction />
  }

  if (isDummyTransaction(transaction)) {
    return null
  }

  const {cardLast4, lastFourDigits, sharesNumber, paymentType} = transaction.publicMeta ?? {}
  const last4 = cardLast4 || lastFourDigits

  return (
    <Notice level="success" className="rounded-lg mb-8">
      <div className="flex items-center gap-4">
        <FaCheckCircle size={20} />
        <div className="">
          <Text type="body" className="!text-green-800">
            {transaction.status === 'paid' ? t('successfulPayment') : null}
            {transaction.status === 'reversed' ? t('reversedPayment') : null}
          </Text>
          <Text type="caption" className="!text-gray-800">
            {paymentType?.label ? (
              <div className="flex space-x-2">
                <b>{paymentType.label}</b>
                {paymentType.value}
              </div>
            ) : last4 ? (
              t('card', {last4})
            ) : null}
            {sharesNumber ? (
              <div className="flex space-x-2">
                <b>{t('installments')}</b>
                {sharesNumber}
              </div>
            ) : null}
          </Text>
        </div>
      </div>
    </Notice>
  )
}
